import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=84e42146&"
import script from "./activity.vue?vue&type=script&lang=ts&"
export * from "./activity.vue?vue&type=script&lang=ts&"
import style0 from "./activity.vue?vue&type=style&index=0&id=84e42146&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports